var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToProg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.05 23.35 5.4 5.25q.6.6.575 1.275-.025.675-.575 1.175-.6.6-1.225.6-.625 0-1.175-.6l-5.7-5.6q-.3-.25-.5-.725t-.2-.975v-8.1q0-.8.475-1.25.475-.45 1.175-.45.8 0 1.275.45.475.45.475 1.25Zm-2.45 19.7q-7.05 0-12.15-4.45-5.1-4.45-6.25-11.15-.2-.95.3-1.825T7 24.65q.85-.05 1.55.4.7.45.9 1.15 1.05 5.2 4.875 8.75T23.6 38.5q6.15 0 10.425-4.3T38.3 23.75q0-6-4.325-10.125T23.6 9.5q-2.9 0-5.575 1.2-2.675 1.2-4.675 3.25h2.4q.75 0 1.25.475t.5 1.275q0 .8-.5 1.275-.5.475-1.25.475H8.6q-1.05 0-1.675-.65T6.3 15.15V8.1q0-.75.475-1.225Q7.25 6.4 7.95 6.4q.8 0 1.275.475Q9.7 7.35 9.7 8.1v3q2.7-2.85 6.3-4.525Q19.6 4.9 23.6 4.9q3.95 0 7.475 1.525 3.525 1.525 6.1 4.075 2.575 2.55 4.125 5.975 1.55 3.425 1.55 7.425t-1.55 7.475q-1.55 3.475-4.125 6.075t-6.1 4.1q-3.525 1.5-7.475 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToProg);
export default __webpack_public_path__ + "static/media/back-to-prog.e4fd4d38c45c2dda6bb738a71a0d35c7.svg";
export { ForwardRef as ReactComponent };